// extracted by mini-css-extract-plugin
export default {"Suspense":"App_Suspense"};